export default "__VITE_ASSET__BMRDmWDH__"